import styled from 'styled-components';
import { TabList } from '@mlb/react-patterns/v4/components/Tabs/tabs';
import Collapsible from './boxscore/boxscoreTeam/boxscoreInfo/Collapsible';

export const BoxScoreViewTypes = {
    WIDE: 'wide',
    NARROW: 'narrow'
};

const { WIDE, NARROW } = BoxScoreViewTypes;
const BoxscoreStyle = `
    &[data-active-tab="home"] {
        div[class*="away-r"] {
            display: none;
        }

    }

    &[data-active-tab="away"] {
        div[class*="home-r"] {
            display: none;
        }
    }
`;

const BoxscoreTeamsGridStyle = `
    position: relative;
    display: grid;
    grid-auto-columns: 50%;
    column-gap: 7px;
    grid-gap: 8px;
    grid-auto-columns: 1fr;
    .away-r1 {
        grid-row: 1/2;
        grid-column: 1/2;
    }
    .away-r2 {
        grid-row: 2/3;
        grid-column: 1/2;
    }

    .away-r3 {
        grid-row: 3/4;
        grid-column: 1/2;
    }

    .away-r4 {
        grid-row: 4/5;
        grid-column: 1/2;
    }

    .away-r5 {
        grid-row: 5/6;
        grid-column: 1/2;
    }

    .away-r6 {
        grid-row: 6/7;
        grid-column: 1/2;
    }

    .away-r7 {
        grid-row: 7/8;
        grid-column: 1/2;
    }

    .home-r1 {
        grid-row: 1/2;
        grid-column: 2/3;
    }

    .home-r2 {
        grid-row: 2/3;
        grid-column: 2/3;
    }

    .home-r3 {
        grid-row: 3/4;
        grid-column: 2/3;
    }

    .home-r4 {
        grid-row: 4/5;
        grid-column: 2/3;
    }

    .home-r5 {
        grid-row: 5/6;
        grid-column: 2/3;
    }

    .home-r6 {
        grid-row: 6/7;
        grid-column: 2/3;
    }

    .home-r7 {
        grid-row: 7/8;
        grid-column: 2/3;
    }
    .away-r1:after {
        content: '';
        position: absolute;
        right: calc(50% + 1px);
        margin-top: -16px;
        height: 100%;
        width: 1px;
        background: var(--gameday-divider-color);
    }
    div[class*="home-r"] {
        padding-left: 16px;
        padding-right: 8px;
    }
    div[class*="away-r"] {
        padding-right: 16px;
    }
`;
export const BoxscoreTeamsGridWrapper = styled.div.attrs({
    'data-mlb-test': 'gamedayBoxscoreTeamsWrapper'
})`
    display: block;
    grid-auto-columns: 1fr;

    ${({ viewType }) => {
        if (viewType === WIDE) {
            return `${BoxscoreTeamsGridStyle}`;
        } else if (viewType === NARROW) {
            return '';
        } else {
            return `
                @media (min-width: 800px) {
                    ${BoxscoreTeamsGridStyle}
                }    
            `;
        }
    }};
    
`;

export const BoxscoreTabs = styled(TabList).attrs({
    'data-mlb-test': 'gamedayBoxscoreTabs'
})`
`;

export const BoxscoreTabsWrapper = styled.div.attrs({
    'data-mlb-test': 'gamedayBoxscoreTabsWrapper'
})`

    border-bottom: 1px solid var(--gameday-divider-color);

    button {
        padding: 0;
        margin: 0 33px 0 0;
        border-bottom: 0;
        color: var(--gameday-tab-button-inactive-color);
        
        &[data-selected=true] {
            color: var(--gameday-tab-button-active-color);
        }

        &:hover {
            border-bottom: 0;
        }
        span {
            font-size: 20px;
            line-height: 20px;
        }

        &[data-selected=true] {
            font-weight: 800;
        }
    }
    
    ${({ viewType }) => {
        if (viewType === WIDE) {
            return `
                display: none;
            `;
        } else if (viewType === NARROW) {
            return `
                display: block;
            `;
        } else {
            return `
                @media (min-width: 800px) {
                    display: none;
                }   
            `;
        }
    }};
`;

export const BoxscoreWrapper = styled.div`
    width: 100%;
    margin-bottom: 32px;
    ${({ viewType }) => {
        if (viewType === NARROW) {
            return `${BoxscoreStyle}`;
        } else if (viewType === WIDE) {
            return '';
        } else {
            return `
                @media (max-width: 799px) {
                    ${BoxscoreStyle}
                }
            `;
        }
    }};
`;

export const GameInfoWrapper = styled.div.attrs({
    'data-mlb-test': 'gamedayBoxscoreGameInfoWrapper'
})`
    font-family: var(--gameday-primary-font);
    font-size: 13px;
    font-weight: 500;
    line-height: 1.54;
`;

export const GameInfo = styled(Collapsible).attrs({
    'data-mlb-test': 'gamedayBoxscoreGameInfo'
})`
`;

export const BoxScrollWrapper = styled.div`
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
`;
